//using this template as a reference for the design of the landing page
//https://land-book.com/websites/50562-maximize-webflow-html-website-template

//use the following reverse geocoding api
//https://www.geoapify.com/get-started-with-maps-api

import "./App.css";
import { useGeolocation } from "./hooks/useGeolocation";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PageNotFound from "./components/PageNotFound";
import LandingPage from "./pages/LandingPage";
import DashBoard from "./pages/DashBoard";
import { useState } from "react";

function App() {
  const { isLoading, position, error, getPosition, setPosition } =
    useGeolocation();
  const [tempColor, setTempColor] = useState(0);
  return (
    <BrowserRouter>
      <Routes>
        <Route
          index
          element={<LandingPage tempColor={tempColor}></LandingPage>}
        ></Route>
        <Route
          path="/dashboard"
          element={
            <DashBoard
              tempColor={tempColor}
              setTempColor={setTempColor}
              position={position}
              getPosition={getPosition}
              setPosition={setPosition}
            ></DashBoard>
          }
        ></Route>
        <Route path="*" element={<PageNotFound></PageNotFound>}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
